var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 32,
    viewBox: "0 0 72 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6809 1.63436C26.5093 0.462782 24.6098 0.462784 23.4383 1.63436L15.9999 9.07269L8.56158 1.63436C7.39001 0.462783 5.49051 0.462784 4.31894 1.63436L1.63429 4.31901C0.462721 5.49058 0.462723 7.39007 1.6343 8.56165L9.07263 16L1.63429 23.4383C0.462721 24.6099 0.462723 26.5094 1.6343 27.681L4.31894 30.3656C5.49052 31.5372 7.39001 31.5372 8.56159 30.3656L15.9999 22.9273L23.4383 30.3656C24.6098 31.5372 26.5093 31.5372 27.6809 30.3656L30.3656 27.681C31.5371 26.5094 31.5371 24.6099 30.3656 23.4383L22.9272 16L30.3656 8.56165C31.5371 7.39007 31.5371 5.49058 30.3656 4.319L27.6809 1.63436Z",
    fill: "#31C3BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9702 15.8706C71.9702 7.10551 64.8647 0 56.0996 0C47.3345 0 40.229 7.10551 40.229 15.8706C40.229 24.6357 47.3345 31.7412 56.0996 31.7412C64.8647 31.7412 71.9702 24.6357 71.9702 15.8706ZM49.6338 15.8706C49.6338 12.2996 52.5286 9.4048 56.0996 9.4048C59.6706 9.4048 62.5654 12.2996 62.5654 15.8706C62.5654 19.4416 59.6706 22.3364 56.0996 22.3364C52.5286 22.3364 49.6338 19.4416 49.6338 15.8706Z",
    fill: "#F2B137"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b0e0e35b.svg";
export { ForwardRef as ReactComponent };